<div class="flex justify-between flex-col h-full">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Check your Email!</h1>
    <div class="text-base opacity-80">
      <p class="mt-2">
        We sent a confirmation email to
        <span class="text-ladder-purpleMedium font-bold">
          {{ email || 'seu@email.com' }}
        </span>.
        <br />
        Click the link <b>in the email</b> to finish your registration.
      </p>
      <div class="mt-4">
        <p>Not finding it?</p>
        <div class="pl-6">
          <ul class="list-disc">
            <li>
              It may take a few minutes to arrive (it shouldn't take long,
              though)
            </li>
            <li>Have you checked the spam folder?</li>
          </ul>
        </div>
      </div>
      <div class="flex justify-center items-center mt-8">
        <img src="assets/imgs/email-sended.svg" class="w-64" />
      </div>
    </div>
  </div>

  <div class="w-full mt-4">
    <app-button (click)="resendEmail()">
      I haven't received the email,
      <span class="font-bold">resend it</span>
    </app-button>
    <div class="text-center mt-4">
      <span class="opacity-65 font-semibold mr-3">Already have an account?</span>
      <a class="text-ladder-purpleMedium underline font-bold" routerLink="/auth/login">Log in</a>
    </div>
  </div>
</div>
